import { Link } from 'react-router-dom';
import { useAuth } from '@leoclinic/hooks';
import { BRAND_COLORS } from '@leoclinic/types';

export function AuthNavLinks() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return null;

  if (isAuthenticated && user?.role === 'client') {
    return (
      <Link
        to="/minhas-marcacoes"
        className="font-medium hover:underline"
        style={{ color: BRAND_COLORS.greenDark }}
      >
        Minhas marcações
      </Link>
    );
  }

  return (
    <>
      <Link
        to="/login"
        className="font-medium hover:underline"
        style={{ color: BRAND_COLORS.greenDark }}
      >
        Entrar
      </Link>
    </>
  );
}
